import Index from '@/pages/org/Index'
import List from '@/pages/org/List'
import Create from '@/pages/org/Create'
import Modify from '@/pages/org/Modify'

export default {
  path: 'organization',
  component: Index,
  children: [
    {
      path: 'index',
      component: List
    },
    {
      path: 'create/:historyid',
      component: Create
    },
    {
      path: 'modify/:historyid/:id',
      component: Modify
    }
  ]
}